<template>
  <div>
    <el-row>
      <el-form :model="ruleForm" ref="ruleForm" label-width="100px" style="overflow: hidden;margin-top:30px"
        class="demo-ruleForm">
        <el-col :span="8">
          <el-form-item label="导入时间" prop="daoruTime">
            <el-date-picker
              v-model="ruleForm.daoruTime"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              size="mini"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item prop="searchString" style="margin-left: 0px;">
            <el-input v-model.trim="ruleForm.searchString" placeholder="订单号、转单号" style="width: 65%;"></el-input>
            <el-button type="primary" @click="search2" style="margin-left:20px;">搜索</el-button>
            <el-button type="primary" @click="resetForm('ruleForm')">重置</el-button>
          </el-form-item>
        </el-col>
      </el-form>
    </el-row>

    <div class="table-body">
      <div class="table-batch">
        <el-button type="primary" @click="dialogVisible=true" style="margin-right: 10px;">
          COD回款导入
        </el-button>
      </div>
      <div class="table-list">
        <el-table width="100%" :data="tableData" border :header-cell-style="{ textAlign: 'center' }" v-loading="loading">
          <el-table-column prop="orderChannelId" label="订单号" align="center"></el-table-column>
          <el-table-column prop="conveyNumber" label="转单号" align="center"></el-table-column>
          <el-table-column prop="paymentCollectedAmount" label="代收货款金额" align="center"></el-table-column>
          <el-table-column prop="refundHandlingFee" label="退款手续费" align="center"></el-table-column>
          <el-table-column prop="currencyCode" label="币种" align="center"></el-table-column>
          <el-table-column prop="createTime" label="导入时间" align="center"></el-table-column>
          <el-table-column label="操作" align="center" width="200">
            <template slot-scope="scope">
              <el-button type="danger" @click="delAdjusting(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    
    <div class="page">
      <el-pagination style="margin-right:200px;" layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[20, 50, 100, 200]" :page-size="pagesize" :current-page="currentPage" :total="total"
        @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
    </div>

    <el-dialog
      title="COD回款导入"
      :visible.sync="dialogVisible"
      width="30%"
      @close="handleUploadExcelDialogClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      destroy-on-close
    >
      <el-row type="flex" align="middle">
        <upload-excel-component :on-success="handleUploadExcelSuccess"/>
        <el-button style="margin-left: 10px;" @click="downloadTemplate">下载模板</el-button>
      </el-row>
      <div class="file-box">
        <span style="color: red">注意：时间格式按照“2022/10/10”填写</span>
      </div>
      <div class="file-box">
        <div v-for="(item, index) in listFile" :key="index">{{ `${ index + 1 }. ${ item.fileName }` }}</div>
      </div>
      <div class="file-box" v-show="errorList">
        <div><span style="color: red">导入异常信息：</span></div>
        <span v-for="(item, index) in errorList" :key="index+'w'">{{ item }}<br /></span>
      </div>
      <div slot="footer">
        <el-button
          size="small"
          @click="handleUploadExcelSubmit"
          :loading="btnLoading"
        >确定导入
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// 库存编辑
// 新增产品库存
import UploadExcelComponent from '@/components/UploadExcel/index.vue'
import { ajaxPost, Baseurl } from '../../../../api/api/api'
export default {
  name: 'FeeImportCOD',
  components: {
    UploadExcelComponent
  },
  data() {
    return {
      currentPage: 1,
      pagesize: 5,
      size: 20,
      total: 0,
      ruleForm: {
        searchString: '',
        daoruTime: []
      },
      tableData: [],
      loading: false,
      dialogVisible: false,
      btnLoading: false,
      listFile: [],
      returnList: [],
      errorList: ''
    }
  },
  created() {
    this.str = JSON.parse(localStorage.getItem('role'))
    this.search()
  },
  watch: {
    dialogVisible(val) {
      if (!val) {
        this.returnList = []
      }
    }
  },
  methods: {
    delAdjusting(id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ajaxPost(Baseurl+'codRefundController/deleteCodRefund', {id}).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
          this.search2()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });          
      });
    },
    handleUploadExcelSubmit() {
      if (!this.returnList.length) {
        this.$message.error("请先导入文件！")
        return
      }
      this.btnLoading = true
      ajaxPost(
        Baseurl + 'codRefundController/importCodRefund/'+this.str.rid, this.returnList
      ).then((res) => {
        if (res.data.code == 200) {
          this.$message.success("成功导入"+res.data.data.successCount+"条数据")
          if (res.data.data.errorList.length) {
            this.errorList = res.data.data.errorList
          } else {
            this.dialogVisible = false
            this.listFile = []
            this.errorList = ''
          }
          this.search()
        } else {
          this.$message.error(res.data.message)
        }
        this.btnLoading = false
      })
    },
    handleUploadExcelSuccess({ results, header, fileName }) {
      let returnList = results.map(item => ({
        orderChannelId: item.订单号,
        conveyNumber: item.转单号,
        paymentCollectedAmount: item.代收货款金额,
        consumptionAmount: item.消耗金额,
        currencyCode: item.币种,
        refundHandlingFee: item.退款手续费,
      }))
      this.returnList.push(...returnList)
      this.listFile.push({fileName})
    },
    downloadTemplate() {
      const a = document.createElement('a')
      a.href = 'https://hyxun-erp-image.oss-cn-hangzhou.aliyuncs.com/file/COD%E5%9B%9E%E6%AC%BE%E5%AF%BC%E5%85%A5.xls'
      a.download = 'https://hyxun-erp-image.oss-cn-hangzhou.aliyuncs.com/file/COD%E5%9B%9E%E6%AC%BE%E5%AF%BC%E5%85%A5.xls'
      a.click()
      this.$message.success('正在下载...')
    },
    handleUploadExcelDialogClose() {
      this.dialogVisible = false
      this.listFile = []
      this.errorList = ''
    },
    search2() {
      this.currentPage = 1
      this.search()
    },
    search() {
      this.loading = true
      if (this.ruleForm.daoruTime.length) {
        this.$set(this.ruleForm, 'startTime', this.ruleForm.daoruTime[0])
        this.$set(this.ruleForm, 'endTime', this.ruleForm.daoruTime[1])
      } else {
        delete this.ruleForm.startTime
        delete this.ruleForm.endTime
      }
      // 库存列表
      var obj = {
        page: this.currentPage,
        size: this.size,
        ...this.ruleForm,
        companyId: this.str.company_id
      }
      ajaxPost(
        Baseurl + 'codRefundController/pageInfo',
        obj
      ).then((res) => {
        if (res.data.code === 200) {
          this.tableData = res.data.data.list
          this.total = res.data.data.total
        }
        this.loading = false
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.ruleForm = {
        searchString: '',
        daoruTime: []
      }
      this.search()
    },
    handleSizeChange(val) {
      this.size = val
      this.search()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.search()
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ {
  .layout .layout-section ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
    background-color: #b71e1e;
  }

  .el-form-item__content {
    margin-left: 0px !important;
  }

  .el-divider--horizontal {
    margin: 15px 0;
  }
}

.adjustingForm {
  /deep/.el-input {
    width: 70%;
    &.el-input--mini {
      width: auto;
    }
  }
}

.table-body {
	width: 100%;
	border: 1px solid #eee;
	overflow: hidden;
}
.table-batch {
  box-sizing: border-box;
  text-align: right;
  padding-right: 20px;
	width: 100%;
	overflow: hidden;
	height: 40px;
	line-height: 40px;
	padding-left: 25px;
}

.information {
  width: 98%;
  overflow: hidden;
  margin-bottom: 50px;
}

.scope_img {
  width: 55px;
  height: 55px;

  img {
    width: 100%;
    height: 100%;
  }
}

.prduct_img {
  width: 300px;
  height: 300px;
}

.padding {
  padding: 5px 0;
}

.line-height {
  line-height: 35px;
}

.page {
  position: fixed;
  width: 100%;
  bottom: 0;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  z-index: 99;
}

.textlang {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.file-box {
  padding-top: 20px;
}
</style>
